import type { SxProps, Theme } from "@mui/material"
import type { MuiLineConfig } from "types/muiLine.types"

export const getStyles = (config: MuiLineConfig): SxProps<Theme> => ({
  "&& .MuiChartsAxis-line, && .MuiChartsAxis-tick": {
    stroke: config.axisColor,
  },
  "& .MuiChartsGrid-line": config.gridStyle,
  "& .MuiLineElement-root": {
    strokeWidth: config.lineWidth,
  },
  "& .MuiHighlightElement-root": {
    display: "none",
  },
})
